<template>
  <v-menu :key="event.title" v-model="event.open" full-width offset-x>
    <template slot="activator" slot-scope="{ on }">
      <div v-ripple class="my-event" v-on="on" v-html="event.title"></div>
    </template>
    <v-card color="grey lighten-4" min-width="350px" flat class="custom-font-regular">
      <v-toolbar color="primary" dark dense>
        <v-toolbar-title v-html="event.title"></v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <span class="grey--text">Descripción:</span><br>
        <pre>{{ event.details }}</pre>
      </v-card-text>
      <v-card-title class="pt-0">
        <div>
          <span class="grey--text">Ubicación:</span><br>
          <span v-html="event.location"></span>
        </div>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small flat color="primary" @click="goToEventDetail(event)">Ver Detalle</v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  props: {
    event: Object,
    hide: Boolean
  },

  methods: {
    goToEventDetail (event) {
      this.$router.push({ name: 'detalleEvento', params: { id: event.pk } })
    }
  },

  watch: {
    'hide' () {
      if (this.hide) {
        this.event.open = false
      }
    }
  }
}
</script>

<style scoped>
.my-event {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-radius: 2px;
  background-color: #1867c0;
  color: #ffffff;
  border: 1px solid #1867c0;
  width: 100%;
  font-size: 12px;
  padding: 3px;
  cursor: pointer;
  margin-bottom: 1px;
}
pre {
  font-family: 'Roboto', sans-serif;
  line-height: 1.5;
}
</style>
